import { ChangeDetectionStrategy, Component, OnInit, Renderer2 } from '@angular/core';
import { TranslationService } from './modules/i18n';
// language list
import { locale as enLang } from './modules/i18n/vocabs/en';
import { locale as chLang } from './modules/i18n/vocabs/ch';
import { locale as esLang } from './modules/i18n/vocabs/es';
import { locale as jpLang } from './modules/i18n/vocabs/jp';
import { locale as deLang } from './modules/i18n/vocabs/de';
import { locale as frLang } from './modules/i18n/vocabs/fr';
import { ThemeModeService } from './_metronic/partials/layout/theme-mode-switcher/theme-mode.service';
import { TemaService } from './core/services/tema.service';
import { PrimeNGConfig } from 'primeng/api';
import { PRIMENG_TR_CEVIRI } from './core/config/tarih.config';

@Component({
  // tslint:disable-next-line:component-selector
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'body[root]',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit {
  constructor(
    private translationService: TranslationService,
    private modeService: ThemeModeService,
    private readonly temaService: TemaService,
    private readonly primengConfig: PrimeNGConfig,
  ) {
    // PrimeNG takviminin (p-calendar → app-datepicker-input) gün/ay adları
    // yalnızca buradan gelir. Bileşen üzerindeki [locale] girdisi PrimeNG 16'da
    // kaldırıldı (setter sadece uyarı basıyor), bkz. core/config/tarih.config.ts.
    this.primengConfig.setTranslation(PRIMENG_TR_CEVIRI);

    // register translations
    this.translationService.loadTranslations(
      enLang,
      chLang,
      esLang,
      jpLang,
      deLang,
      frLang
    );
  }

  ngOnInit() {
    this.modeService.init();
    // Kullanıcı tipine göre sidebar ve aksan rengini uygular; kullanıcı
    // değiştikçe (giriş, çıkış, rol simülasyonu) kendini günceller.
    this.temaService.baslat();
  }

}
